/**
 * Unbranded theme for public pages whose resource opted out of branding
 * (e.g. a scheduling poll created with includeBranding: false). Carries no
 * partner identity — `base` is VoiceArchive blue, which is branding too.
 *
 * The semantic colours are deliberately left alone: positive/warning/negative
 * carry meaning on those pages (available / maybe / unavailable) rather than
 * brand identity.
 */
export default {
  primary: {
    lighter: '#6b7280',
    default: '#4b5563',
    darker: '#374151',
  },
  secondary: {
    lighter: '#d1d5db',
    default: '#9ca3af',
    darker: '#6b7280',
  },
  tertiary: {
    lighter: '#9ca3af',
    default: '#6b7280',
    darker: '#4b5563',
  },
  positive: {
    default: '#78C091',
  },
  negative: {
    default: '#ea6258',
  },
  grayscale: {
    darker: '#121212',
    default: '#212121',
    lighter: '#535353',
  },
  warning: {
    darker: '#caba04',
    default: '#eab308',
    lighter: '#facc15',
  },
}
